import React, { useRef, useState, useEffect } from 'react'
import { DatePicker } from 'antd'
import type { Dayjs } from 'dayjs'
import { FilterDateIcon } from '../../../iconsV2'
import clsx from 'clsx'
import styles from '../SAPPCalendar.module.css'

interface Props {
  currentDate: Dayjs
  setCurrentDate: (d: Dayjs) => void
  calendarMode: 'week' | 'month' | 'day'
}

const CustomDatePicker = ({ currentDate, setCurrentDate, calendarMode }: Props) => {
  const [visible, setVisible] = useState(false)
  const wrapperRef = useRef<HTMLDivElement>(null)

  const handleIconClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    setVisible((prev) => !prev)
  }

  const handleDateChange = (date: Dayjs | null) => {
    if (date) {
      setCurrentDate(date)
    }
  }

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const popup = document.querySelector('.ant-picker-dropdown');
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target as Node) &&
        !(popup && popup.contains(e.target as Node))
      ) {
        setVisible(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  return (
    <div
      ref={wrapperRef}
      style={{ position: 'relative', height: 'fit-content' }}
    >
      <div
        onClick={handleIconClick}
        className={clsx(styles['hover-item'], styles['btn-icon'], 'cursor-pointer', visible && styles['btn--active'])}
      >
        <FilterDateIcon />
      </div>

      <DatePicker
        style={{ position: 'absolute', opacity: 0, pointerEvents: 'none', width: '38px' }}
        open={visible}
        value={currentDate}
        onChange={handleDateChange}
        placement='bottomRight'
        picker={
          calendarMode === 'day'
            ? 'date'
            : calendarMode === 'week'
            ? 'week'
            : 'month'
        }
      components={{
         input: (inputProps) => (
           <input
             {...inputProps}
             style={{
               position: 'absolute',
               opacity: 0.001,
               left: 0,
               top: 0,
               zIndex: -1,
               width: '100%',
               height: '100%',
               pointerEvents: 'auto'  
             }}
           />
         ),
      }}
        allowClear={false}
        suffixIcon={null}
        getPopupContainer={() => document.body}
        popupStyle={{ pointerEvents: 'auto', zIndex: 9999 }}
      />
    </div>
  )
}

export default CustomDatePicker
